import { Dialog } from "@material-ui/core";
import { StyledPaper } from "../../../../components/addBankPopup/styles";
import { CloseButton } from "../reviewForm/styles";
import CloseIcon from "@material-ui/icons/Close";
import { FormTitle } from "../../../homePage/styles";
import { SmallTitleText } from "../../../underwriterDashboard/idpDocuments/styles";
import { InfoArea } from "../styles";
import { FunctionalButton } from "../../../../components/functionalButton";
import React from "react";
import PylonIcon from "../../../../assets/common/pylonIcon.png";

type UnderwritersNotAvailablePopupProps = {
  open: boolean;
  setOpen: (open: boolean) => void;
};

export const UnderwritersNotAvailablePopup = ({
  open,
  setOpen,
}: UnderwritersNotAvailablePopupProps) => {
  const handleClose = () => {
    setOpen(false);
  };

  return (
    <Dialog
      open={open}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      maxWidth="md"
      TransitionComponent={React.Fragment}
    >
      <StyledPaper elevation={0} style={{ width: "700px", height: "500px" }}>
        <CloseButton onClick={handleClose} aria-label="close">
          <CloseIcon />
        </CloseButton>
        <img src={PylonIcon} />
        <FormTitle style={{ margin: "15px 0" }}>
          Underwriters Not Available
        </FormTitle>
        <SmallTitleText>
          Would you like to invite the available underwriters?
        </SmallTitleText>
        <InfoArea>
          <div
            style={{
              display: "flex",
              gap: "10px",
              minWidth: "600px",
              justifyContent: "center",
            }}
          >
            <FunctionalButton
              buttonTitle="Cancel"
              handleButton={handleClose}
              width="250px"
              height={undefined}
              isReversedColor={true}
              marginRight={undefined}
              marginLeft={undefined}
              marginTop={undefined}
              marginBottom={undefined}
              fontSize={undefined}
              disabled={undefined}
              icon={undefined}
              hasBoxShadow={undefined}
              frontIcon={undefined}
              weight={undefined}
              borderColor={undefined}
              selected={undefined}
            />
            <FunctionalButton
              buttonTitle="Confirm"
              handleButton={() => {}}
              width="250px"
              height={undefined}
              isReversedColor={undefined}
              marginRight={undefined}
              marginLeft={undefined}
              marginTop={undefined}
              marginBottom={undefined}
              fontSize={undefined}
              disabled={undefined}
              icon={undefined}
              hasBoxShadow={undefined}
              frontIcon={undefined}
              weight={undefined}
              borderColor={undefined}
              selected={undefined}
            />
          </div>
        </InfoArea>
      </StyledPaper>
    </Dialog>
  );
};
